function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.13 2v58a2.08 2.08 0 003.35 1.65L31.07 44.3a1.37 1.37 0 011.67 0l22.51 17.32A2.08 2.08 0 0058.6 60V2z",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 3.84
});

function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+Ym9va21hcms8L3RpdGxlPjxwYXRoIGQ9Ik01LjEzLDJWNjBhMi4wOCwyLjA4LDAsMCwwLDMuMzUsMS42NUwzMS4wNyw0NC4zYTEuMzcsMS4zNywwLDAsMSwxLjY3LDBMNTUuMjUsNjEuNjJBMi4wOCwyLjA4LDAsMCwwLDU4LjYsNjBWMloiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMy44NCIvPjwvc3ZnPg==";
export { SvgBookmark as ReactComponent };